import * as React from "react";
const SvgStop = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, rx: 2, fill: "currentColor" }));
export {
  SvgStop as default
};
//# sourceMappingURL=stop.js.map
